import React, { useCallback, useEffect, useState } from 'react'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subscibeTo } from 'app/common/data-box-store'
import { classesListFilterSelection, dayCaresListFilterSelection, defaultStudentListDataReceiver, studentListFilter, studentListFilterSelection } from 'app/dataProviders/filter-items'


type Props = {
  id: string
  pending: boolean
}

export const StudentListFilter = ({ id, pending }: Props) => {
  const [filterVisibility, setFilterVisibility] = useState<boolean>(false)

  const handleStudents = useCallback((data: string[]) => {
    if (data.length === 1) {
      studentListFilter.addDataReceiver(
        defaultStudentListDataReceiver,
      )
      studentListFilter.dataReceive()
      studentListFilter.setStatusReady()
      setFilterVisibility(true)
      return
    }
    studentListFilter.resetToDefault()
    setFilterVisibility(false)
  }, [])

  useEffect(() => {
    const classesListUnsubscribe = subscibeTo<string[]>(classesListFilterSelection.id, handleStudents)
    const dayCaresListUnsubscribe = subscibeTo<string[]>(dayCaresListFilterSelection.id, handleStudents)
    return (() => {
      classesListUnsubscribe()
      dayCaresListUnsubscribe()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    filterVisibility
    && <PlainItemsSelectorBox
      id={id}
      label="Учащийся"
      header="Выбор учащегося"
      dataBoxData={studentListFilter}
      dataBoxSelection={studentListFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      disabled={pending}
    />
  )
}
